<template>
  <VehicleDetailsHost />
</template>
<script>
import VehicleDetailsHost from '@/components/dashboard/VehicleDetailsHost.vue'
export default {
  name: 'VehicleDetailsView',
  components: {
    VehicleDetailsHost
  }
}
</script>
<style lang="scss" scoped></style>
